// extracted by mini-css-extract-plugin
export var collapseWrapper = "Blocks-module--collapseWrapper--3dLyC";
export var illustration = "Blocks-module--illustration--2lzAS";
export var spinAround = "Blocks-module--spinAround--2PKmx";